import Spinner from 'react-bootstrap/Spinner'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'

/** Obal chráněných rout. Vynucuje přihlášení i změnu dočasného hesla. */
export function RequireAuth({ adminOnly = false }: { adminOnly?: boolean }) {
    const { user, isLoading } = useAuth()
    const location = useLocation()

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" />
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/prihlaseni" state={{ from: location.pathname }} replace />
    }

    // Dokud si uživatel nezmění dočasné heslo, nesmí do aplikace.
    if (user.mustChangePassword && location.pathname !== '/zmena-hesla') {
        return <Navigate to="/zmena-hesla" replace />
    }

    if (adminOnly && !user.isAdmin) {
        return <Navigate to="/" replace />
    }

    return <Outlet />
}
